import { Nav } from "../../layouts/Nav/Nav";
import { Footer } from "../../layouts/Footer/Footer";
import "../../styles/PrivacyPolice.scss";

export function PrivacyPolice() {
  return (
    <>
      <div className="container">
        <div className="nav-container">
          <Nav />
        </div>

        <div className="police-content">
          <h1>PRIVACY POLICY</h1>
          <div>
            <p>
              Thank you for having interest in our company and the application
              Storiya.app (hereinafter: Application) we have created for you. We
              take the protection of your personal data very seriously and we
              process your data in accordance with the applicable legal
              provisions for the protection of personal data, in particular with
              Regulation (EU) 2016/679 of the European Parliament and of the
              Council of 27 April 2016 on the protection of natural persons with
              regard to the processing of personal data and on the free movement
              of such data (and repealing Directive 95/46/EC (hereinafter:
              General Data Protection Regulation - GDPR) and applicable national
              regulations on personal data protection.
            </p>
          </div>
          <div>
            <p>
              Cypher as the Data Controller hereby informs you comprehensively
              about this Privacy Policy with respect to processing of your
              personal data and your rights as the User of our Application.
            </p>
          </div>
          <div>
            <p>
              Personal data is the information that makes it possible to
              identify a natural person. Anonymous data exists if no personal
              reference can be established to the User. We process your personal
              data lawfully, fair and transparently. Use of Application is
              related to the services of our external partners, including but
              not limited to the company Google LLC. Please check the websites
              of these providers for their terms of use and data protection
              regulations since their processing may have impact on your rights.
            </p>
          </div>
          <div>
            <h4>IDENTITY AND CONTACT DETAILS OF THE CONTROLLER</h4>
            <ul className="data_police">
              <li>Medulinska 2, 31 000 Osijek, Republic of Croatia</li>
              <li>registered with the Commercial Court Osijek</li>
              <li>MBS: 030249088</li>
              <li>PIN: 14765764374</li>
              <li>(hereinafter : Cypher) https://Storiya.app/privacy-policy</li>
            </ul>
          </div>

          <div>
            <h4>TYPES OF PERSONAL DATA</h4>
            <p>
              As a part of the use of the Application, Cypher only processes the
              personal data provided by the Users of the Application to Cypher
              upon Registration and Sign In, while communicating with Cypher and
              while using the Application, namely:
            </p>
            <ul className="data_police">
              <li>Email address</li>
              <li>
                Personal data contained in Google or Facebook user account.
              </li>
            </ul>
          </div>

          <div>
            <h4>THE PURPOSE OF PERSONAL DATA PROCESSING</h4>
            <p>
              1. Cypher shall process the personal data referred to in this
              Privacy Policy for the purpose of:
            </p>
            <ul className="data_police">
              <li>
                registering and recording / identifying the Application Users,
              </li>
              <li>
                performing all actions necessary to enable the use of the
                Application and fulfil the obligations that arise from the use
                of the Application,
              </li>
              <li>proper operation of the Application,</li>
              <li>contacting the Application User in case of complaints.</li>
            </ul>
            <p>
              The provision of such personal data is necessary for registering
              users in the Application and for using the Application. The User
              is obliged to provide this information to Cypher because the User
              shall otherwise not be able to use the Application and all of its
              functionalities. The processing of personal data for these
              purposes is necessary for the use of the Application. Therefore,
              the legal basis for processing personal data for these purposes is
              Article 6 (1)(b) of the General Data Protection Regulation
              (processing is necessary for the performance of a contract to
              which the data subject is party or in order to take steps at the
              request of the data subject prior to entering into a contract).
              The legal basis for processing personal data for the purpose of
              identifying the person (user) is Article 6(1)(c) of the General
              Data Protection Regulation (processing is necessary for compliance
              with a legal obligation to which the controller is subject).
            </p>
            <p>
              2. On the basis of the specific written consent of the Application
              User, Cypher shall process the personal information of the
              Application User referred to in this Privacy Policy for the
              purpose of:
            </p>
            <ul className="data_police">
              <li>
                profiling the Application User for the preparation of customized
                offers of goods and services using e-mail, SMS, MMS, telephone;
              </li>
              <li>
                direct marketing and notifying the Application User of the
                offers, promotional sales and other benefits, as well as other
                changes or news of the Cypher;
              </li>
              <li>
                conducting market research on the quality of products and
                services and the need for additional products or services;
              </li>
            </ul>
            <p>
              The legal basis for processing personal data for these purposes is
              Article 6 (1)(a) of the General Data Protection Regulation (the
              data subject has given consent to the processing of their personal
              data for one or more specific purposes). This processing of
              personal data involves profiling but not automated decision
              making.
            </p>
          </div>

          <div>
            <h2>THE RECIPIENTS OR CATEGORIES OF PERSONAL DATA RECIPIENTS</h2>
            <div>
              <p>
                Cypher handles personal data carefully and prevents access by
                unauthorised persons. In certain cases, due to individual
                examples of processing that Cypher does not perform on its own,
                the personal data of the Application User may be provided to
                contractors - external processors who process the data on behalf
                of, for the account of, under the instructions of and under the
                supervision of Cypher.
              </p>
              <p>
                If the personal data that is collected and processed is
                transferred outside the EU to a third country or an
                international organization, Cypher checks whether there is a
                permission to send the data in the form of a so-called Decisions
                on adequacy, which Decision is issued by the European Commission
                and which is published in the Official Gazette of Europe. If
                there is no such decision, appropriate protective measures are
                applied, such as contracting standard data protection clauses.
              </p>
              <p>
                All personal data processed by the Application are stored on
                Google LLC serves in the USA, which company is included in the
                Data Privacy Framework list available at:
                https://www.dataprivacyframework.gov/s/ , which enables free
                transfer of personal data.{" "}
              </p>
            </div>
            <div>
              <h2>THE PERIOD FOR WHICH THE PERSONAL DATA WILL BE STORED</h2>
              <p>
                The personal data referred to in this clause shall be stored
                until the cancellation of the use of Application by an
                individual User or, in the case of processing personal data
                based on the User's consent, until the User withdraws the given
                consent or submits a request for the deletion of personal data.
                In the event of a dispute, the existence of open issues
                regarding rights and obligations from the contract, or other
                circumstances determined by law, longer processing of data is
                possible until such issues are finally eliminated or resolved.
              </p>
            </div>

            <div>
              <h4>YOUR RIGHTS AS A DATA SUBJECT</h4>
              <p>
                Firstly, we would like to inform you about your rights as a data
                subject. These rights are standardised in Articles 15 - 22 of
                EU-GDPR. This comprises:
              </p>
              <ul className="data_police">
                <li>Right of access (Art. 15 EU-GDPR),</li>
                <li>Right to erasure (Art. 17 EU-GDPR),</li>
                <li>Right to rectification (Art. 16 EU-GDPR),</li>
                <li>Right to data portability (Art. 20 EU-GDPR),</li>
                <li>Right to restriction of processing (Art. 18 EU-GDPR),</li>
                <li>
                  Right to object to processing of data (Art. 21 EU-GDPR).
                </li>
              </ul>
              <p>
                1. The User may request information on which personal data
                relating to him/her has been stored, how the data was collected,
                and for what purpose.
              </p>
              <p>
                2. If personal data is transmitted to third parties, information
                must be given about the identity of the recipient or the
                categories of recipients.
              </p>
              <p>
                3. If personal data is incorrect or incomplete, the data subject
                may demand these to be corrected or supplemented.
              </p>
              <p>
                4. The data subject can object to the processing of his or her
                data for purposes of advertising or market/opinion research.
              </p>
              <p>
                5. The User may request his/her data to be deleted by sending
                the request to: Storiya.app/data-delete, if the processing of
                such data has no legal basis, or if the legal basis has ceased
                to apply. The same applies if the purpose behind the data
                processing has lapsed or ceased to be applicable for other
                reasons. In the event that the User of the Application requests
                the deletion of personal data necessary for the use of the
                Application, Cypher will cancel/block/disable its use after
                deleting the personal data. You have a right of appeal to a data
                protection supervisory authority. Such authority competent in
                the Republic of Croatia is Data Protection Agency with the seat
                in Zagreb, Selska cesta 136, www.azop.hr
              </p>
            </div>

            <div>
              <h2>CONFIDENTIALITY OF PROCESSING</h2>
              <p>
                Personal data is subject to data secrecy. Any unauthorized
                collection, processing, or use of such data is prohibited.
              </p>
            </div>

            <div>
              <h2>COOKIES</h2>
              <p>
                The website https://Storiya.app/ uses necessary cookies and
                other types of cookies for which you may provide your consent in
                accordance with the notifications and options contained in
                cookie banner.
              </p>
            </div>

            <div>
              <h2>AMENDING THE PRIVACY POLICY</h2>
              <p>
                We may update our Privacy Policy from time to time. Therefore,
                we advise you to periodically review this page. We will notify
                you of any changes by posting the new Privacy Policy on this
                page.
              </p>
              <p>
                If you have any questions or suggestions regarding our Privacy
                Policy, please feel free to contact us via the contact form at
                https://Storiya.app .
              </p>
              <br />
            </div>

            <div>
              <p>These Rules apply from 16th of January 2024.</p>
            </div>
          </div>
        </div>
        <div className="footer">
          <Footer />
        </div>
      </div>
    </>
  );
}
